import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import common from "./en/common.json";
import clients from "./en/clients.json";
import auditLogs from "./en/auditLogs.json";
import organization from "./en/organization.json";
import participant from "./en/participant.json";
import program from "./en/program.json";
import roles from "./en/roles.json";
import user from "./en/user.json";
import geofence from "./en/geofence.json";

export const defaultNS = "common";

i18next.use(initReactI18next).init({
  lng: "en", // if you"re using a language detector, do not define the lng option
  debug: true,
  resources: {
    en: {
      common,
      clients,
      auditLogs,
      geofence,
      organization,
      participant,
      program,
      roles,
      user,
    },
  },
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
});
